import React from 'react'
import {EmailLookup} from '../../EmailLookup'
import {Button} from '../../../shared/Button'
import {
  StepCardWrapper,
  StepCard,
  FooterRow,
  FooterCenter,
} from '../AccountSetup.styles'

// Wraps the shared EmailLookup component with this wizard's StepCard/footer
// card look, matching every other step. EmailLookup itself is NOT given its
// own StepCard/Footer the way AccountInfo/SchedulingStep/PaymentDetailsStep/
// CatalogSelectionStep were, because — unlike those — it's also reused
// as-is by AddAccountModal and ProposalTool's proposal-creation flow, each
// with their own chrome; wrapping it here instead of editing EmailLookup
// itself keeps those other callers completely unaffected.
export function EmailLookupStep({
  keapPartnerId,
  onReady,
  onCancel,
  ...footerProps
}) {
  return (
    <StepCardWrapper fitContent>
      <StepCard>
        <EmailLookup keapPartnerId={keapPartnerId} onReady={onReady} />
      </StepCard>

      <EmailLookupStepFooter onCancel={onCancel} {...footerProps} />
    </StepCardWrapper>
  )
}

// This step's own footer card — a sibling below StepCard, not inside it.
// Unlike Scheduling/PaymentDetails/Catalog (which only ever need Cancel or
// Cancel+Continue), email-lookup is the one step that can still show the
// generic Back/Continue pair (see AccountSetup/index.js's showNavButtons).
export function EmailLookupStepFooter({
  onCancel,
  showBackContinue,
  onBack,
  canGoBack,
  onContinue,
  canProceed,
}) {
  return (
    <FooterRow>
      <FooterCenter>
        <Button variant="secondary-gray" size="sm" onClick={onCancel}>
          Cancel
        </Button>
      </FooterCenter>

      {showBackContinue && (
        <FooterCenter>
          <Button
            variant="secondary-blue"
            size="sm"
            onClick={onBack}
            disabled={!canGoBack}
          >
            &lt; Back
          </Button>

          <Button
            variant="secondary-blue"
            size="sm"
            onClick={onContinue}
            disabled={!canProceed}
          >
            Continue &gt;
          </Button>
        </FooterCenter>
      )}
    </FooterRow>
  )
}
